import ApplicationController  from "./application_controller"

export default class extends ApplicationController {
    static targets = [];

    connect() {
        super.connect();
        this.form = this.element;
        this.element[this.identifier] = this;
    }

    composeEmail() {
        if (this.form.email.value != "") {
            window.open("mailto:" + this.form.email.value);
        }

    }

    selectPostcode() {
        var w = window.open("/postcodes/select.html", "pcselect", "left=600,screenX=600,top=80,screenY=100,menubar=no,toolbar=no,width=400,height=600,resizable=yes", false);
        w.focus();
        // remember which window we created
        window.pc_popup = w;
    }

    postcodeSelected( { detail } ) {
        this.log('postcodeSelected', [detail]);
        this.form.postcode.value = detail.postcode;
        this.form.gemeente.value = detail.naam;
        window.pc_popup.close();
    }

    selectBijlid() {
        var w = window.open("/leden/select.html?type=B;zonder_hoofdlid=1", "lidselect", "left=600,screenX=600,top=80,screenY=100,menubar=no,toolbar=no,width=500,height=600,resizable=yes", false);
        w.focus();
        // remember which window we created
        window.bl_popup = w;
    }

    bijlidSelected({ detail }) {
        this.log('bijlidSelected', [detail]);

        let dt = this.form.querySelector("#dynatable_bijleden");
        dt.dynatable.addItem({ bijlid_ids: detail.id, bijlid_naam: detail.voornaam + " " + detail.naam });

        // dynatable_bijleden.addItem({bijlid_ids: data[0], bijlid_naam: data[2] + " " + data[1]});
        // give focus back to popup or close it
        window.bl_popup.close();
    }


    addAfdeling() {
        var listbox = this.form.selectafdeling;

        if (listbox.selectedIndex > 0) {
            let value = listbox.options[listbox.selectedIndex].value;
            let text = listbox.options[listbox.selectedIndex].text;

            let dt = this.form.querySelector("#dynatable_afdelingen");
            dt.dynatable.addItem({ afd_ids: value, afd_naam: text });
        }
    }

    addGroep() {
        var listbox = this.form.selectgroep;
        if (listbox.selectedIndex > 0) {
            let value = listbox.options[listbox.selectedIndex].value;
            let text = listbox.options[listbox.selectedIndex].text;

            let dt = this.form.querySelector("#dynatable_groepen");
            dt.dynatable.addItem({groep_ids: value, groep_naam: text });
        }
    }


    disconnect() {
        this.element[this.identifier] = null;
        super.disconnect();
    }
}
